import { client } from './API';

export function fetchTenantStores() {
  return client.get(`/api/tenant-stores`).then(response => response.data);
}
